import { staleTimes, useQuery } from '@platform/api-client';
import type { Operation, ResponseBody, TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';

export type StockOverview = ResponseBody<Operation<'/admin/dashboard/stock', 'get'>>;
export type DepotStock = StockOverview['depots'][number];
export type UrgentItem = StockOverview['urgent'][number];

export type StockScope = { readonly productId?: string | null; readonly optionValueId?: string | null };

const scopeQuery = (company: string | null, { productId = null, optionValueId = null }: StockScope) => ({
  ...(company === null ? {} : { company }),
  ...(productId === null ? {} : { product_id: productId }),
  ...(optionValueId === null ? {} : { option_value_id: optionValueId }),
});

export const useStockOverview = (api: TypedClient, company: string | null, scope: StockScope = {}) => {
  const { tenantId } = usePageContext();
  const query = scopeQuery(company, scope);
  return useQuery({
    queryKey: [...queryKeys.stockOverview(tenantId), query],
    queryFn: () => api.get('/admin/dashboard/stock', { query }),
    staleTime: staleTimes.dashboard,
  });
};
